import { useEffect, useState } from 'react'

export function useWindowResize(breakPoint?: number) {
  const [isBreak, setIsBreak] = useState<boolean>(false)

  useEffect(() => {
    const checkResize = () => {
      if (typeof breakPoint === 'number') {
        setIsBreak(window.innerWidth <= breakPoint)
      }
    }

    checkResize()

    window.addEventListener('resize', checkResize)

    return () => {
      window.removeEventListener('resize', checkResize)
    }
  }, [])

  return isBreak
}
